import { Grid, FormControlLabel, Checkbox, Typography } from '@mui/material';

const MAPPING_ORDER = [
  'view employee mapping',
  'add employee mapping',
  'edit employee mapping',
  'remove employee mapping'
];

const ATTENDANCE_ORDER = [
  'view employee attendance',
  'import attendance',
  'download attendance report'
];

const nameOf = (item) => String(item?.name || '').trim().toLowerCase();

const isMappingPermission = (item) => nameOf(item).includes('employee mapping');

const byOrder = (order) => (left, right) => {
  const leftIndex = order.indexOf(nameOf(left));
  const rightIndex = order.indexOf(nameOf(right));
  return (
    (leftIndex === -1 ? order.length : leftIndex) -
    (rightIndex === -1 ? order.length : rightIndex)
  );
};

const TabFifteen = ({ attendanceData, setAttendanceData, isEdit = false }) => {
  const permissions = Array.isArray(attendanceData) ? attendanceData : [];
  const attendancePermissions = permissions
    .filter((item) => !isMappingPermission(item))
    .sort(byOrder(ATTENDANCE_ORDER));
  const mappingPermissions = permissions
    .filter(isMappingPermission)
    .sort(byOrder(MAPPING_ORDER));

  const setChecked = (group, checked) => {
    const ids = new Set(group.map((item) => item.id));
    setAttendanceData(
      permissions.map((item) => (ids.has(item.id) ? { ...item, value: checked } : item))
    );
  };

  const renderPermissions = (group) =>
    group.map((data) => {
      const index = permissions.findIndex((item) => item.id === data.id);
      return (
        <Grid item xs={6} key={data.id || data.name}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={isEdit}
                checked={permissions[index]?.value || false}
                onChange={() => {
                  const items = [...permissions];
                  items[index] = {
                    id: data.id,
                    name: data.name,
                    tab: data.tab,
                    value: !data.value
                  };
                  setAttendanceData(items);
                }}
              />
            }
            label={data.name}
          />
        </Grid>
      );
    });

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 1 }}>
        <Typography sx={{ pt: 2 }} variant="h5">
          Attendance
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <FormControlLabel
          id="attendance-form-all"
          control={
            <Checkbox
              id="attendance-all"
              checked={
                attendancePermissions.length > 0 &&
                attendancePermissions.every((item) => item.value)
              }
              onChange={(event) => setChecked(attendancePermissions, event.target.checked)}
              disabled={isEdit}
            />
          }
          label="All"
        />
      </Grid>
      {renderPermissions(attendancePermissions)}
      <Grid item xs={12} sx={{ mt: 1 }}>
        <Typography sx={{ pt: 2 }} variant="h5">
          Employee Mapping
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <FormControlLabel
          id="employee-mapping-form-all"
          control={
            <Checkbox
              id="employee-mapping-all"
              checked={
                mappingPermissions.length > 0 && mappingPermissions.every((item) => item.value)
              }
              onChange={(event) => setChecked(mappingPermissions, event.target.checked)}
              disabled={isEdit}
            />
          }
          label="All"
        />
      </Grid>
      {renderPermissions(mappingPermissions)}
    </Grid>
  );
};

export default TabFifteen;
